import type {Guide} from '@blesk-frontend/api';
import {formatLongDate} from '../../libs';
import {cropImage} from './cropImage';

export const copyAsMarkdown = async (guide: Guide) => {
  const md = `#### ${guide.user.fullName} - ${formatLongDate(guide.createdAt)}
# ${guide.name}

${guide.description}

${
  guide.steps.length
    ? (
        await Promise.all(
          guide.steps
            .filter((step) => !step.payload.meta.hidden)
            .sort((a, b) => a.position - b.position)
            .map(async (step, index) => {
              const imgSrc = await cropImage(step.payload);
              const stepText = step.payload.element.text;
              return `${index + 1} – ${stepText}${
                imgSrc
                  ? `
![image](${imgSrc})`
                  : ''
              }`;
            }),
        )
      ).join(`

`)
    : ''
}`;

  try {
    const clipboardItem = new ClipboardItem({
      'text/plain': new Blob([md], {type: 'text/plain'}),
    });

    await navigator.clipboard.write([clipboardItem]);
  } catch (error) {
    alert(`Ошибка копирования: ${error}`);
  }
};
